import React from 'react';
import '../App.css';
import sairImg from '../images/sair.png';

const baseUrl = window.location.protocol + '//' + window.location.host;


export default class ProfileMenu extends React.Component {

  logout() {
    let url = window.location.protocol + '//' + window.location.host;
    try {
      console.log(`Attempting to logout via url: ${url}/api/v1/users/logout`);
      fetch(`/api/v1/users/logout`, {method: 'DELETE'}, function(err, data) {
        if (err) {
          console.log('Error attempting to logout: ' + err);
        } else {
          console.log('Sair response: ' + JSON.stringify(data));
          // This should probably get a redirect from the back end instead.
          window.location = '/';
        }
      });
    } catch(e) {
      console.log('Error logging out: ' + e);
    }
  };

  showProfile(e) {
    // Get parent App object and fire off setState with a profile specified
    console.log('User clicked showProfile...');
    e.preventDefault();
    this.props.app.showProfile(this.props.user);
  }

  switchMode(e, org_mode) {
    // Have to update the user to set org_mode to true, which will cause
    //   content to be filtered by organization.
    e.preventDefault();
    console.log('Submitting user update... Org mode is: ' + org_mode);
    let that = this;
    let reqData = new FormData();
      // uri: `${baseUrl}/api/v1/users/${this.props.user._id['$oid']}`,
    reqData.append('form[user][org_mode]', org_mode);
    try {
      fetch(`/api/v1/users/${this.props.user._id['$oid']}`, {body: reqData, method: 'PUT'}, function(err, data) {
        if (err) {
          console.log('Error submitting new post!: ' + err);
        }   
        if (data) {
          console.log(' Got data from user update: ' + JSON.stringify(data));
          // alert('Update successful.');
          window.location.reload();
          if (that.uploadedStringImage) {
            // reload so that all occurences of the avatar get updated.
            window.location.reload();
          } else {
            that.setState({editing: false});
          }   
        }   
      }); 
    } catch(e) {
      console.log('Post creation error: ' + e); 
    }   
  }

  render() {
    let mode = 'Mundo';
    let otherMode = undefined;
    let orgMode = false;
    let otherModeString = '';
    console.log('  USER');
    console.log(this.props.user);
    if (this.props.user.org_mode && this.props.user.organization) {
      mode = this.props.user.organization.name;
      otherMode = 'Mundo';
    } else if (this.props.user.organization) {
      otherMode = this.props.user.organization.name;
    }
    if (otherMode) {
      otherModeString = '(Troca para moda ' + otherMode + ')';
    }
    if (otherMode && otherMode === 'Mundo') {
      orgMode = false;
    } else if (otherMode && otherMode !== 'Mundo') {
      orgMode = true;
    }
    return (
      <div className='profileMenu'>
        <div id='hideStuff' onClick={(e) => this.showProfile(e)} className='profileName'>
          <span className='fakeLink' id='hideStuff' onClick={(e) => this.showProfile(e)}><img id='hideStuff' onClick={(e) => this.showProfile(e)} src={this.props.avatar} alt='' className='avatar' /></span>
          <div className='profileMenuLabel'>
            <span className='fakeLink' id='hideStuff' onClick={(e) => this.showProfile(e)}>{this.props.username}</span>
          </div>
        </div>
        <br />
        <div className='profileName'>
          <span className='fakeLink' onClick={this.logout}><img src={sairImg} alt='Sair' className='avatar' onClick={this.logout} /></span>
          <div className='profileMenuLabel'>
            <span className='menuItem' onClick={this.logout}>Sair</span>
          </div>
        </div>
        <br />
        <div className='profileName'>
          Moda: {mode}
          <br />
          <div className='profileMenuLabel'>
            <span className='menuItem' onClick={(e) => this.switchMode(e, orgMode)}>{otherModeString}</span>
          </div>
        </div>
      </div>
    );
  }
}
